import Link from "next/link";

import { normalizeTnsName } from "@coinbot/forge-api/external";

import { Search } from "~/assets";
import { ListingRowItem } from "~/components/common/ListingRowItem";
import { SearchInput } from "~/components/common/SearchInput";
import { FormField, Popover, PopoverClose, PopoverContent, PopoverTrigger } from "~/components/ui";
import { useNavbarSearch } from "../useNavbarSearch";

export function NavbarMobileSearch() {
  const { isPopoverOpen, setIsPopoverOpen, onSubmit, tnsItems, isFetched, isFetching, isEmpty } =
    useNavbarSearch();

  return (
    <Popover open={isPopoverOpen} onOpenChange={setIsPopoverOpen}>
      <PopoverTrigger>
        <Search className="h-5 w-5 fill-white" />
      </PopoverTrigger>

      <PopoverContent
        className="flex h-[var(--radix-popover-content-available-height)] w-[100vw] flex-col !p-0 pt-10 md:w-[580px] md:max-w-[580px]"
        side="bottom"
        sideOffset={26}
        align="end"
        alignOffset={-21}
      >
        <PopoverClose />

        <div className="mt-14 bg-popover px-8">
          <FormField
            name="search"
            render={({ field }) => (
              <form onSubmit={onSubmit}>
                <SearchInput
                  isLoading={isFetching}
                  /* eslint-disable-next-line jsx-a11y/no-autofocus */
                  autoFocus
                  {...field}
                  value={field?.value?.toLowerCase()}
                />
              </form>
            )}
          />
        </div>

        <div className="mt-4 flex w-full flex-1 flex-col bg-search-gradient px-5">
          <div className="w-full rounded-xs py-4 md:w-[500px]">
            {tnsItems?.map((tns) => {
              return (
                <Link
                  href={
                    tns?.type === "unregistered_thorname"
                      ? `/register?tns=${encodeURIComponent(normalizeTnsName(tns?.name))}`
                      : `/tns/${normalizeTnsName(tns?.name)}`
                  }
                  key={`popover-tcr-item-${tns?.id}-${tns?.name}`}
                  onClick={() => setIsPopoverOpen(false)}
                >
                  <ListingRowItem tns={tns} />
                </Link>
              );
            })}

            {isFetched ? (
              isEmpty && (
                <div className="py-2 text-center text-lg font-medium">No results found</div>
              )
            ) : (
              <div className="py-2 text-center text-lg font-medium">Searching THORNames...</div>
            )}

            {/* <div className="mt-5 border-b border-white pb-1 text-sm uppercase">Category Name</div>

            <CategoryRowItem category={category} />
            */}
          </div>
        </div>
      </PopoverContent>
    </Popover>
  );
}
